export default [
  {
    'nome': 'NF',
    'id' : 0
  },
  {
    'nome': 'FT',
    'id': 1
  },
  {
    'nome': 'RC',
    'id': 2
  },
  {
    'nome': 'DI',
    'id': 3
  },
  {
    'nome': 'GRU',
    'id': 4
  },
  {
    'nome': 'CTE',
    'id': 5
  },
  {
    'nome': 'NFe',
    'id': 6
  },
  {
    'nome': ' ',
    'id': -1
  },
];



// WEBPACK FOOTER //
// ./FrontEnd/modulos/solicitacao-pagamento/juridica/tipos-documento.js